import { useEffect } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const ProtectedUserRoute = ({ children }) => {
  const { user, logout } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    // If logged in but account is inactive, logout and redirect
    if (user && user.status !== "active") {
      logout(); // clear cookie + user state
      navigate("/signin?reason=deactivated", { replace: true });
    }
  }, [user, logout, navigate]);

  if (!user) {
    return <Navigate to="/signin" state={{ from: location }} replace />;
  }

  return children;
};

export default ProtectedUserRoute;
